module.exports = __webpack_public_path__ + "img/basicIndexScore.d7e9bc3f.png";